'use strict';

module.exports = require('./InputGroup');


//////////////////
// WEBPACK FOOTER
// ./~/_bee-input-group@1.0.5@bee-input-group/build/index.js
// module id = 409
// module chunks = 0